import {Button, Dropdown, ToolbarButton} from '@wordpress/components';
import type {BlockEditProps} from '@wordpress/blocks';
import Section, {type AllFields} from './widget-styles/Section';
import Settings from './widget-styles/Settings';
import {__} from '@wordpress/i18n';
import {CONFIG} from '../../globals/config';
import {select} from '@wordpress/data';
import {useState} from 'react';
import {InspectorControls} from '@wordpress/block-editor';
import type {ClosableSections} from '../../hooks/useOpenSection';

import styles from './widget-styles.pcss';


export type StyleOptions = {
	apply_current_page_styles_to_parent?: boolean;
	apply_current_page_parent_styles_to_parent?: boolean;
	block_style?: boolean;
	border?: boolean;
	border_color?: string;
	border_width?: number | string; // number for legacy values
	bullet_style?: string;

	// Attributes automatically added by `supports.color` when registering the block.
	backgroundColor?: string;
	gradient?: string;
	style?: {
		color?: {
			background?: string;
			gradient?: string;
			text?: string;
			link?: string;
		}
	}
	closed_sections: ClosableSections[];
} & AllFields;

export type Props = Pick<BlockEditProps<StyleOptions>, 'attributes' | 'setAttributes'>;

const WidgetStyles = ( {attributes, setAttributes}: Props ) => {
	const post = select( 'core/editor' )?.getCurrentPost() ?? null;
	const [ isDropdownOpen, setIsDropdownOpen ] = useState( false );
	const [ closing, setClosing ] = useState<boolean>( false );

	return ( <>
		<InspectorControls group={'filter'}>
			<div className={styles.buttonWrap + ' components-panel__body is-opened'}>
				<Button
					isSecondary
					icon={'admin-appearance'}
					isPressed={isDropdownOpen}
					onClick={() => {
						if ( closing ) {
							return;
						}
						setIsDropdownOpen( ! isDropdownOpen );
					}}
				>
					{isDropdownOpen ? __( 'Close Menu Styles', 'advanced-sidebar-menu' ) : __( 'Open Menu Styles', 'advanced-sidebar-menu' )}
				</Button>
			</div>
		</InspectorControls>

		<Dropdown
			contentClassName={styles.dropdown}
			open={isDropdownOpen}
			onClose={() => {
				setClosing( true );
				setTimeout( () => setClosing( false ), 500 );
				setIsDropdownOpen( false );
			}}
			renderToggle={( {onToggle} ) => <ToolbarButton
				title={__( 'Menu Styles', 'advanced-sidebar-menu' )}
				onClick={() => {
					setIsDropdownOpen( ! isDropdownOpen );
					onToggle();
				}}
				icon={'admin-appearance'}
				isActive={isDropdownOpen}
			/>}
			renderContent={() => (
				<div className={styles.wrap}>
					<Settings attributes={attributes} setAttributes={setAttributes} />

					{CONFIG.styles.sections.map( section => <Section
						key={section.prefix}
						attributes={attributes}
						post={post}
						setAttributes={setAttributes}
						section={section} /> )}
				</div>
			)}
		/>
	</> );
};

export default WidgetStyles;
